export function scrollToElement(id: string) {
  const element = document.querySelector(`[data-testid="${id}"]`);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}
